"use client";

import { Menu, X } from "lucide-react";
import Link from "next/link";
import { Button } from "../ui/button";
import { useState } from "react";
import { ModeToggle } from "../theme-toggle";
import { usePathname } from "next/navigation";
import Image from "next/image";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const pathname = usePathname();

  const navItems = [
    // "Home",
    "About",
    "Programs",
    "Gallery",
    // "Blog",
    "Testimonials",
    "Support Us",
    "Contact",
  ];

  return (
    <>
      <div className="bg-primary px-4 py-2 text-center text-sm font-medium text-primary-foreground sm:text-base cursor-pointer hover:bg-primary/90 transition-colors group">
        <Link
          href="/online-admission"
          className="flex items-center justify-center gap-2 w-full h-full"
        >
          <span className="animate-pulse">✨</span>
          Admissions are now open for the Academic Year 2083! Secure your
          placement today.
          <span className="hidden sm:inline-block ml-2 underline underline-offset-2 font-bold group-hover:translate-x-1 transition-transform">
            Apply Now &rarr;
          </span>
        </Link>
      </div>
      <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto  flex h-16 items-center justify-between py-4">
          <div className="flex items-center gap-2">
            <Image
              src="/logoschool.png"
              alt="Janakalyan Boarding School"
              className="h-8 w-8 object-cover bg-secondary dark:bg-primary rounded-full"
              width={40}
              height={40}
            />
            <Link href={"/"}>
              <span className="text-xl font-bold">
                Shree Janakalyan Boarding School
              </span>
            </Link>
            {/* <span className="sm:hidden text-lg font-bold">
            SJKBS
          </span> */}
          </div>

          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <Link
                key={item}
                href={
                  item === "Home"
                    ? "/"
                    : item === "Support Us"
                      ? "/support-us"
                      : `/${item.toLowerCase()}`
                }
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  pathname ===
                  (item === "Support Us"
                    ? "/support-us"
                    : `/${item.toLowerCase()}`)
                    ? "text-primary"
                    : ""
                }`}
              >
                {item}
              </Link>
            ))}
            <Link
              href="/ai"
              className={`ai-button ${pathname === "/ai" ? "active" : ""}`}
            >
              <span className="relative z-10">AI</span>
              <span className="animated-border" />
            </Link>
          </nav>

          <div className="flex items-center gap-2 mr-2">
            <ModeToggle />

            <Button
              variant="ghost"
              size="sm"
              className="md:hidden p-2"
              onClick={toggleMenu}
            >
              {isMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </Button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-4 py-3 text-center space-y-1 bg-background border-t">
              {navItems.map((item) => (
                <>
                  <Link
                    key={item}
                    href={
                      item === "Home"
                        ? "/"
                        : item === "Support Us"
                          ? "/support-us"
                          : `/${item.toLowerCase()}`
                    }
                    className="block py-2 px-3 text-sm font-medium hover:bg-muted rounded-md"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item}
                  </Link>
                </>
              ))}
              <Button asChild className="w-full text-center">
                <Link
                  href="/ai"
                  className={`ai-button ${pathname === "/ai" ? "active" : ""}`}
                >
                  <span className="relative z-10">AI</span>
                  <span className="animated-border" />
                </Link>
              </Button>
              <div className="flex gap-2 mt-4">
                <Button variant="outline" size="sm" className="flex-1">
                  Student Login
                </Button>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};
